import activate from './activate'
import assigned_locations from './assigned_locations'
import auth from './auth'
import change_email from "./change_email";
import create from './create'
import del from './delete'
import forgotPassword from './forgot_password'
import list from './list'
import notifications from "./notifications"
import notification_preference from "./notification_preference";
import profile from './profile'
import projects from "./projects"
import project_downloads from "./project_downloads"
import project_invites from "./project_invites"
import register from './register'
import resetPassword from './reset_password'
import show from './show'
import update from './update'

export default {
  namespaced: true,
  modules: {
    activate,
    assigned_locations,
    auth,
    change_email,
    create,
    del,
    forgotPassword,
    list,
    notifications,
    notification_preference,
    profile,
    projects,
    project_downloads,
    project_invites,
    register,
    resetPassword,
    show,
    update,
  }
}
